import Anagata1 from '../../../Media/KHI/Anagata.webp'
import Anagata2 from '../../../Media/KHI/Anagata.webp'


const Anagataimages =[
Anagata1,Anagata2
]

export default Anagataimages;